import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { RouteBlock, TrackingTrailLegend } from "@ryde/layout";
import { usePageContext, useRidesNavigation } from "@ryde/redux";
import {
  IRideRoute,
  IRideTableDto,
  isLiveMapFullDisplayMode,
  liveMapAutofitSuspendedAtom,
  liveMapEffectiveDisplayModeSelector,
  liveMapRideRoutesSF,
  MapRouteBlockTypeEnum,
  useSystemParams,
} from "@ryde/shared";

import { LiveMapIncidentsLayerMapLibre } from "./live-map.incidents-layer.maplibre";

interface ILiveMapMapInner {
  mapRides: IRideTableDto[];
  trackingCarRoutes: IRideRoute[];
}

export const LiveMapMapInner: FC<ILiveMapMapInner> = ({
  mapRides,
  trackingCarRoutes,
}) => {
  const { entity } = usePageContext();
  const { isRidesEditRoute } = useRidesNavigation();
  const { enableIncidents } = useSystemParams();
  const rideRoutes = useRecoilValue(liveMapRideRoutesSF(entity));
  const liveMapDisplayMode = useRecoilValue(
    liveMapEffectiveDisplayModeSelector,
  );
  const isMapRenderDeferred = useRecoilValue(liveMapAutofitSuspendedAtom);

  const displayMapCondition = useMemo((): boolean => {
    return !isRidesEditRoute;
  }, [isRidesEditRoute]);

  const isLegendVisible =
    !isMapRenderDeferred &&
    isLiveMapFullDisplayMode(liveMapDisplayMode) &&
    mapRides.length > 0;

  return (
    <RouteBlock
      hiddenMapState={!displayMapCondition}
      routes={rideRoutes}
      trackingCarRoutes={trackingCarRoutes}
      rideDto={mapRides.length === 1 ? mapRides[0] : undefined}
      routeBlockType={MapRouteBlockTypeEnum.LiveMap}
      liveMapDisplayMode={liveMapDisplayMode}
      mapExtraLayers={
        <>
          {enableIncidents && <LiveMapIncidentsLayerMapLibre />}
          {isLegendVisible && <TrackingTrailLegend />}
        </>
      }
    />
  );
};
